import { render, staticRenderFns } from "./TelefoneCelularField.vue?vue&type=template&id=f8b0cc14&scoped=true&"
import script from "./TelefoneCelularField.vue?vue&type=script&lang=js&"
export * from "./TelefoneCelularField.vue?vue&type=script&lang=js&"
import style0 from "./TelefoneCelularField.vue?vue&type=style&index=0&id=f8b0cc14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b0cc14",
  null
  
)

export default component.exports